import React, { useState } from "react";
import GrowthVsTmTable from "./growthVsTmTable";
import GrowthVsTMScatterChart from "./growthVsTMScatterChart";

type props = {
  commGrowthFilter: string;
  setCommGrowthFilter: React.Dispatch<React.SetStateAction<string>>;
  salesGrowthFilter: string;
  setSalesGrowthFilter: React.Dispatch<React.SetStateAction<string>>;
  tpGrowthFilter: string;
  setTpGrowthFilter: React.Dispatch<React.SetStateAction<string>>;
  drill: "Up" | "Down";
  setDrill: React.Dispatch<React.SetStateAction<"Up" | "Down">>;
  activeIndex: string;
  setActiveIndex: React.Dispatch<React.SetStateAction<string>>;
  salesData: Array<Record<string, string>>;
  data: {
    axisData: { xSplit: number; ySplit: number };
    graphData: Array<
      Record<string, string | number> & { x: number; y: number; z: number }
    >;
    tableData: Array<
      Record<string, string | number> & {
        tm: number;
        sales: number;
        growth: number;
      }
    >;
    XYTicksData: { xTicks: number[]; yTicks: number[] };
  };
  isLoadingReportGrowthVsTmData: boolean;
};
const GrowthVsTM = ({
  commGrowthFilter,
  setCommGrowthFilter,
  salesGrowthFilter,
  setSalesGrowthFilter,
  tpGrowthFilter,
  setTpGrowthFilter,
  drill,
  setDrill,
  activeIndex,
  setActiveIndex,
  salesData,
  data,
  isLoadingReportGrowthVsTmData,
}: props) => {
  //   const [drill, setDrill] = useState<"Up" | "Down">("Down");
  return (
    <div className="w-full h-full flex justify-between items-center gap-1">
      <GrowthVsTMScatterChart
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        commGrowthFilter={commGrowthFilter}
        setCommGrowthFilter={setCommGrowthFilter}
        salesGrowthFilter={salesGrowthFilter}
        setSalesGrowthFilter={setSalesGrowthFilter}
        tpGrowthFilter={tpGrowthFilter}
        setTpGrowthFilter={setTpGrowthFilter}
        drill={drill}
        setDrill={setDrill}
        salesData={salesData}
        graphData={data.graphData}
        axisData={data.axisData}
        XYTicksData={data.XYTicksData}
      />
      {activeIndex !== "" && (
        <GrowthVsTmTable
          activeIndex={activeIndex}
          commGrowthFilter={commGrowthFilter}
          salesGrowthFilter={salesGrowthFilter}
          tpGrowthFilter={tpGrowthFilter}
          drill={drill}
          tableDataOG={data.tableData}
          isLoadingReportGrowthVsTmData={isLoadingReportGrowthVsTmData}
        />
      )}
    </div>
  );
};

export default GrowthVsTM;
